import React from "react";

const ContactCard = ({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
}) => {
  return (
    <div
      className="group w-full max-w-[430px] overflow-hidden rounded-2xl border border-red-100 bg-white/92 shadow-[0_10px_24px_rgba(127,29,29,0.08)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(127,29,29,0.12)]"
    >
      <div className="flex items-center gap-2.5 px-3.5 py-2.5 text-left sm:px-4 sm:py-3">
        <div className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-red-100 bg-white text-red-600 shadow-[0_8px_18px_rgba(127,29,29,0.08)] transition-transform duration-300 group-hover:scale-105">
          <span className="absolute inset-0 rounded-2xl bg-red-50/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <span className="relative">{icon}</span>
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-[8.5px] font-semibold uppercase tracking-[0.18em] text-red-600/90">
            Kết nối nhanh
          </p>
          <h3 className="mt-0.5 text-[13.5px] font-semibold leading-tight text-[#2f1a1a] sm:text-[14.5px]">
            {title}
          </h3>
          <p className="mt-0.5 text-[11.5px] leading-5 text-slate-500 sm:text-[12px]">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
